import React from 'react'
import { useMediaQuery } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/core/styles'
import theme from './theme'
import App from './views/App/App'
import CalculatorProvider from './components/Context/CalculatorContext'

const AppLoader = () => {
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')

    return (
        <CalculatorProvider>
            <ThemeProvider theme={theme(prefersDarkMode)}>
                <App />
            </ThemeProvider>
        </CalculatorProvider>
    )
}

export default AppLoader
